module.exports = __webpack_public_path__ + "img/horizontal_4_3_r_pp3_6000.9b4b7341.png";